import type { NodeMouseEvent } from 'components/Graph/GraphApp/events/GraphAppEvents';
import type { GraphRendererPlugin } from 'components/Graph/GraphApp/plugins/GraphRendererPlugin';
import { openNodeContextMenu } from 'components/Graph/commands/nodes/openNodeContextMenu';
import { getGraphMouseEventPosition } from '../helpers/getGraphMouseEventPosition';

export const nodeContextMenu: GraphRendererPlugin = (pluginInterface) => {
  pluginInterface.events.addListener('nodeAdded', (nodeAddedEvent) => {
    nodeAddedEvent.node.on('rightdown', (rightDownEvent: NodeMouseEvent) => {
      // delay to prevent immediately closing due to considering current event to be "click outside"
      setTimeout(() => {
        pluginInterface.graphDispatch(openNodeContextMenu, {
          nodeId: nodeAddedEvent.id,
          position: getGraphMouseEventPosition(rightDownEvent),
        });
      }, 0);
    });
  });
};
